import React, { Component } from "react";

import Carousel from "./Carousel";
import Image from "./Image";

class PictureCarousel extends Component {
  renderImages = (imageArray) => {
    return imageArray.map((pic, i) => {
      return (
        <div key={i} style={{ padding: "1.25rem 0.5rem" }}>
          <Image pictures={this.props.pictures} image={pic} />
        </div>
      );
    });
  };

  render() {
    var pictures = this.props.pictures;
    return (
      <div>
        {pictures.length > 0 ? (
          <div style={{ padding: "0 15px" }}>
            <Carousel
              render={this.renderImages}
              items={pictures}
              theme={"images"}
            />
            <div
              style={{
                width: "100%",
                borderTop: "1px solid #00568E",
                padding: "20px 0 ",
              }}
            ></div>
          </div>
        ) : (
          <div
            style={{
              padding: "1.25rem",
            }}
          >
            Es sind keine Fotos für die Mühle vorhanden.
          </div>
        )}
      </div>
    );
  }
}

export default PictureCarousel;
